<template>
  <div class="p-box">
    <div v-if="!availablePlanLoading && availablePlan" class="p-box__body">
      <div class="c-grid">
        <h2 class="c-pageTitle">{{ $t('pages.companies.paymentSetting.availablePlan.title') }}</h2>
      </div>
      <div class="p-list">
        <ul class="p-list__items">
          <li v-if="availablePlan.attributes.plan" class="p-list__item">
            <div class="p-list__title">{{ $t('pages.companies.paymentSetting.availablePlan.currentPlan') }}: </div>
            <div class="p-list__content">
              {{ $t('labels.plan.' + availablePlan.attributes.plan) }}
            </div>
          </li>
          <li class="p-list__item">
            <div class="p-list__title">{{ $t('pages.companies.paymentSetting.availablePlan.availableStoreSlots') }}: </div>
            <div class="p-list__content">{{ $t('pages.companies.paymentSetting.availablePlan.maxStoreCount', { number: availablePlan.attributes.max_store_count }) }}</div>
            <div class="u-colorPrimary">{{ $t('pages.companies.paymentSetting.availablePlan.currentStoreCount', { number: availablePlan.attributes.current_store_count }) }}</div>
          </li>
          <li v-if="parsedNextPaymentAt" class="p-list__item">
            <div class="p-list__title">{{ $t('pages.companies.paymentSetting.paymentMethod.nextBillingDate') }}: </div>
            <div class="p-list__content">
              {{ parsedNextPaymentAt }}
            </div>
          </li>
          <li v-if="availablePlan.attributes.next_payment_amount" class="p-list__item">
            <div class="p-list__title">{{ $t('pages.companies.paymentSetting.availablePlan.nextBillingAmount') }}: </div>
            <div class="p-list__content">{{ $t('labels.currency.yen', { number: Number(availablePlan.attributes.next_payment_amount).toLocaleString() }) }}</div>
          </li>
        </ul>
      </div>
      <div class="c-button c-button--right">
        <template v-if="availablePlan.attributes.payment_method === 'credit_card'">
          <a class="aboutPlan" :href="aboutPlanUrl" target="_blank">
            {{ $t('pages.companies.paymentSetting.availablePlan.aboutPlan') }}
          </a>
          <router-link :to="{ name: 'CompaniesChangePlan', params: { company_uuid: currentCompanyUuid }}" class="c-button__item c-button__item--outline">
            {{ $t('pages.companies.paymentSetting.availablePlan.changePlan') }}
          </router-link>
        </template>
        <template v-if="availablePlan.attributes.payment_method === 'credit_card'">
          <router-link :to="{ name: 'UpgradePlan', params: { company_uuid: currentCompanyUuid }}" class="c-button__item c-button__item--primary">
            {{ $t('pages.companies.paymentSetting.availablePlan.ApplyForAdditionalStoreSlots') }}
          </router-link>
        </template>
        <template v-if="availablePlan.attributes.payment_method === 'other'">
          <a class="aboutPlan" :href="aboutPlanUrl" target="_blank">
            {{ $t('pages.companies.paymentSetting.availablePlan.aboutPlan') }}
          </a>
          <button class="c-button__item c-button__item--primary" @click="openUpgradeRequestModal">
            {{ $t('pages.companies.paymentSetting.availablePlan.ApplyForUpgradePlan') }}
          </button>
        </template>
      </div>
      <UpgradeRequestModal
        :show-modal="showUpgradeRequestModal"
        :loading="stockRequestsLoading"
        :store-count="availablePlan.attributes.max_store_count"
        :plan-id="availablePlan.attributes.plan"
        :plan-list="planList"
        @close="closeUpgradeRequestModal"
        @submit="sendUpgradeRequestModal"
      />
    </div>
    <Loading v-show="availablePlanLoading" />
  </div>
</template>

<script>
import {mapActions, mapState, mapGetters} from 'vuex'
import Loading from '../Loading'
import moment from 'moment'
import UpgradeRequestModal from './UpgradeRequestModal.vue'

export default {
  name: 'AvailablePlan',
  components: {
    Loading,
    UpgradeRequestModal
  },
  data() {
    return {
      showUpgradeRequestModal: false,
    }
  },
  computed: {
    ...mapState({
      availablePlan: state => state.companiesAvailablePlan.data,
      availablePlanLoading: state => state.companiesAvailablePlan.loading,
      stockRequestsLoading: state => state.companiesStockRequests.loading,
    }),
    ...mapGetters({
      useServiceName: 'companiesCompany/useServiceName',
    }),
    currentCompanyUuid() {
      return this.$route.params.company_uuid
    },
    parsedNextPaymentAt() {
      if (!this.availablePlan.attributes.next_payment_at) { return }
      return moment(new Date(this.availablePlan.attributes.next_payment_at)).format(this.$t('format.date.default'))
    },
    planList() {
      const obj = {}
      obj[this.$t('labels.plan.entry')] = 'entry'
      obj[this.$t('labels.plan.small')] = 'small'
      obj[this.$t('labels.plan.lite')] = 'lite'
      obj[this.$t('labels.plan.basic')] = 'basic'
      return obj
    },
    aboutPlanUrl() {
      switch(this.useServiceName) {
      case 'kcom':
        return 'https://kutikomi.com/plan/'
      case 'localone':
        return 'https://localone'
      default:
        return ''
      }
    },
  },
  created() {
    this.readAvailablePlan(this.currentCompanyUuid)
  },
  methods: {
    ...mapActions({
      readAvailablePlan: 'companiesAvailablePlan/readAvailablePlan',
      createStockRequests: 'companiesStockRequests/createStockRequests',
    }),
    openUpgradeRequestModal() {
      this.showUpgradeRequestModal = true
    },
    closeUpgradeRequestModal() {
      this.showUpgradeRequestModal = false
    },
    async sendUpgradeRequestModal(values) {
      await this.createStockRequests({ company_uuid: this.$route.params.company_uuid, payload: { store_count: values.storeCount, plan: values.planId } })

      this.closeUpgradeRequestModal()
    },
  },
}
</script>

<style lang="scss" scoped>
.aboutPlan {
  margin-right: 10px;
  text-decoration: none;
  color: #E9446A;
}
</style>
